/**
 * Created by liwenqiang on 2018/3/27.
 */

require('../global/global');
require('../global/base/layout.scss');
require('./index/index.scss');
require('../global/css/crumbs.scss');



//////////////////
// WEBPACK FOOTER
// ./src/project/index.page.js
// module id = 43
// module chunks = 3